<template>
  <v-card flat>
    <v-card-title>
      Check Out Today
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        text="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="partnerCheckoutTodayBookings"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="fancy"><router-link :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id }}"><a class="text-dark"><u>{{props.item.booking_ref_code}}</u></a></router-link></td>
        <td class="fancy">{{ props.item.booking_done_by}}</td>
        <td class="fancy">{{ props.item.guest_total}}</td>
        <td class="fancy">{{props.item.currency}} {{props.item.total_cost}}</td>
        <td class="fancy">{{ props.item.booking_status}}</td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'PartnerCheckOutToday',
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Ref',
          value: 'booking_ref_code'
        },
        {
          text: 'Client Name',
          value: 'booking_done_by'
        },
        {
          text: 'Number of Guests',
          value: 'guest_total'
        },
        {
          text: 'Amount'
        },
        {
          text: 'Status',
          value: 'booking_status'
        }
      ]
    }
  },
  methods: {
    checkOut: function (publicId) {
      this.$store.dispatch('check_out_dash', publicId)
    }
  }
}
</script>

<style scoped>

</style>
